import { render, staticRenderFns } from "./IconPanel.vue?vue&type=template&id=3fcab3fe&"
import script from "./IconPanel.vue?vue&type=script&lang=js&"
export * from "./IconPanel.vue?vue&type=script&lang=js&"
import style0 from "./IconPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports